import { MutableRefObject, useCallback, useEffect } from "react";
import { default as WaveSurferRef } from "wavesurfer.js";
import { useAtomValue } from "jotai";
import { mediaElementAtom } from "../../atoms/audioAtom";

export const useSetupOnClick = (
  ref: MutableRefObject<WaveSurferRef | null>,
  notReady: boolean,
) => {
  const audioElement = useAtomValue(mediaElementAtom);

  const handleSeek = useCallback(
    (time: number) => {
      if (!audioElement) {
        return;
      }
      audioElement.currentTime = time;
    },
    [audioElement],
  );

  useEffect(() => {
    if (notReady || !ref.current) return;
    ref.current.on("interaction", handleSeek);
  }, [handleSeek, notReady, ref.current]);
};
